import Search from '@op/components/FilterBoxCommon/filters/search';
import CustomSelect from '@op/components/FilterCommon/components/CustomSelect';
import RenderGameIcon from '@op/components/RenderImg/renderGameIcon';
import useLanguage from '@op/hooks/useLanguage';
import React, { useEffect, useMemo, useState } from 'react';
import { Button, Justify } from 'tea-component';
import './index.scss';
import { goStatsDetailAction } from '@op/pages/stats/Detail';
import SvgIcon from '@home/components/SvgIcon';

export default function Filter({
  change,
  gameList,
  filter
}: {
  change: (key: string, value: Array<string> | string) => void;
  gameList: Array<any>;
  filter: any;
}) {
  const { formatMessage } = useLanguage();

  return (
    <Justify
      style={{ marginBottom: 20 }}
      left={
        <div className='dbo-header-operations'>
          <GameSelected gameList={gameList} change={change}>
          </GameSelected>
          <Button
            onClick={() => {
              goStatsDetailAction({
                path: '/opinion/AIAnalysisHub/CustomAISummary',
                params: filter,
                history,
              });
            }}
            type={'primary'}
            className='dbo-ai-task-center-btn'
          >
            <span>{formatMessage({ id: 'Go to AI Analysis Hub' })}</span>
            <SvgIcon type="arrow-right" className="card-slot-icon" />
          </Button>
        </div>
      }
      right={
        <Search
          key="search"
          openBlurSearch
          defaultParams={{
            style: { width: 300 },
            placeholder: formatMessage('Search Analysis Name'),
            onSearch: (value: string) => {
              change('search_text', value);
            },

          }}
        ></Search>
      }
    />
  );
}

function GameSelected({
  change,
  gameList,
}: {
  change: (key: string, value: Array<string>) => void;
  gameList: Array<any>;
}) {
  const { formatMessage } = useLanguage();
  const [select, setSelect] = useState<Array<string>>([]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    if (gameList.length > 0) {
      setSelect(gameList.map((item) => item.edition_unified_id));
    }
  }, [gameList]);

  const { basicOptions, length } = useMemo(() => {
    const options = gameList.map((item) => {
      const text =
        item.entity_name || item.entity_name_en || item.entity_name_cn;
      return {
        text,
        value: item.edition_unified_id,
      };
    });
    return {
      basicOptions: options,
      length: options.length,
    };
  }, [gameList]);

  const options = useMemo(() => {
    return gameList
      .map((item) => {
        const text =
          item.entity_name || item.entity_name_en || item.entity_name_cn;
        const searchText = text.toLocaleLowerCase();
        if (searchText.includes(search.toLocaleLowerCase())) {
          return {
            text,
            value: item.edition_unified_id,
            gameInfo: item,
          };
        }

        return null;
      })
      .filter((item) => item !== null);
  }, [gameList, search]);

  return (
    <CustomSelect
      options={options}
      basicOptions={basicOptions}
      selectOptionsInfo={[select, setSelect]}
      placeholderText={formatMessage({ id: 'Game' })}
      searchInfo={[search, setSearch]}
      matchButtonWidth={false}
      boxClassName="dbo-ai-task-game-select"
      optionItemRender={(text: string, value: string, item: any) => {
        return (
          <div className="dbo-game-item-box">
            <RenderGameIcon
              className="dbo-game-item-img"
              imgStyle={{ width: 20, height: 20 }}
              gameInfo={item.gameInfo}
            ></RenderGameIcon>
            <span className="dbo-game-item-text">{text}</span>
          </div>
        );
      }}
      onChange={(value: Array<string>) => {
        change('edition_unified_ids', value.length === length ? [] : value);
      }}
    ></CustomSelect>
  );
}
